import messages from '../../../../locale/messages';

const isEmpty = value => value === undefined || value === null || String(value).trim() === '';

const isNumber = value => !isNaN(parseFloat(value)) && isFinite(value);

function validateAmount(value) {
    if (isEmpty(value)) return messages.required;
    if (!isNumber(value)) return messages.positiveNumber;
    if (Number(value) < 0) return messages.positiveNumber;
    return undefined;
}

function validatePercentage(value) {
    if (isEmpty(value)) return messages.required;
    if (!isNumber(value)) return messages.percentageRange;
    if (Number(value) < 0 || Number(value) > 100) return messages.percentageRange;
    return undefined;
}

const validate = values => {
    const errors = {};

    if (isEmpty(values.locationId)) errors.locationId = messages.required;
    if (isEmpty(values.categoryId)) errors.categoryId = messages.required;
    if (isEmpty(values.currency)) errors.currency = messages.required;

    ['basePrice', 'unitPrice', 'minutePrice', 'baseFare', 'waitingPrice'].forEach(field => {
        const error = validateAmount(values[field]);
        if (error) errors[field] = error;
    });

    ['riderFeeValue', 'driverFeeValue'].forEach(field => {
        const error = validatePercentage(values[field]);
        if (error) errors[field] = error;
    });

    const isSurgePrice = values.isSurgePrice == true || values.isSurgePrice == 'true';

    if (isSurgePrice && values.surgePricing && values.surgePricing.length > 0) {
        const surgeErrors = [];

        values.surgePricing.forEach((item, index) => {
            const itemErrors = {};
            const pricingType = item && Number(item.pricingType);

            if (pricingType === 1 && isEmpty(item.datePricingValue)) {
                itemErrors.datePricingValue = messages.required;
            }

            if (pricingType === 2 && isEmpty(item.dayPricingValue)) {
                itemErrors.dayPricingValue = messages.required;
            }

            if (isEmpty(item.surgeValue) || !isNumber(item.surgeValue) || Number(item.surgeValue) <= 0) {
                itemErrors.surgeValue = messages.surgeValueRange;
            }

            if (!isEmpty(item.startTime) && !isEmpty(item.endTime)
                && Number(item.endTime) <= Number(item.startTime)) {
                itemErrors.endTime = messages.endTimeAfterStartTime;
            }

            surgeErrors[index] = itemErrors;
        });

        if (surgeErrors.some(item => Object.keys(item).length > 0)) {
            errors.surgePricing = surgeErrors;
        }
    }

    return errors;
};

export default validate;
